module.exports = __webpack_public_path__ + "img/user.60b4d3ec.svg";